<template>
  <hmn-massive-recruitment :is-my-processes="true" />
</template>

<script>
import HmnMassiveRecruitment from "./HmnMassiveRecruitment.vue";

export default {
  name: "HmnMyMassiveRecruitment",
  components: {
    HmnMassiveRecruitment,
  },
};
</script>
